import * as React from 'react';

import Tooltip from 'components/Tooltip';
import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';

import { __t, applyTranslations } from 'utils/language';
import { getInfluencerLocationsPreview } from 'utils/influencers';

import type { ProposalCreatorProfile } from 'types';

import './proposal-tile-header.scss';
import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

applyTranslations(require('./proposal-tile-header.i18n.json'));

type Props = {
  creatorProfile: ProposalCreatorProfile,
  isForBrand: boolean,
  showWarning: boolean
};

const ProposalTileHeader: React.FunctionComponent<Props> = (
  {
    creatorProfile,
    isForBrand,
    showWarning
  }: Props
): JSX.Element => {
  const age = creatorProfile.age;
  const location = getInfluencerLocationsPreview(creatorProfile.locations);

  return (
    <div className="proposal-tile-header">
      <Tooltip
        message={__t('proposal_tile_header.avatar_tooltip')}
        width="auto-compact"
      >
        <EntityAvatar
          entity={{
            image: creatorProfile.profileImage
          }}
          link={`/content-creator/profiles/${creatorProfile.id}`}
          customSize={{ width: 80, height: 80 }}
          openInNewTab
        />
      </Tooltip>
      <div className="proposal-tile-header__info">
        <div className="proposal-tile-header__name text-overflow-ellipsis">
          {
            !isForBrand ?
              <a
                href={`/content-creator/profiles/${creatorProfile.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="proposal-tile-header__standard-link text-overflow-ellipsis"
              >
                {creatorProfile.name}
              </a> :
              creatorProfile.name
          }
        </div>
        <div className="proposal-tile-header__subline">
          {
            Boolean(age) && (
              <span
                key="age"
                className="proposal-tile-header__subline-item"
              >
                <span className="proposal-tile-header__subline-label">
                  {__t('proposal_tile_header.age_label')}
                </span>
                <span className="proposal-tile-header__subline-value">
                  {age}
                </span>
              </span>
            )
          }
          {
            Boolean(location && location.length) && (
              <span
                key="location"
                className="proposal-tile-header__subline-item"
              >
                <span className="proposal-tile-header__subline-label">
                  {__t('proposal_tile_header.location_label')}
                </span>
                <span className="proposal-tile-header__subline-value text-overflow-ellipsis">
                  {location[0]}
                  {
                    location.length > 1 && (
                      <Tooltip
                        message={`${location.slice(1).join('<br />')}`}
                        width="auto-compact"
                      >
                        &nbsp;{`(+${location.length - 1} ${__t('proposal_tile_header.locations_more_label')})`}
                      </Tooltip>
                    )
                  }
                </span>
              </span>
            )
          }
        </div>
      </div>
      {
        showWarning && (
          <div className="proposal-tile-header__warning">
            <span className="proposal-tile-header__warning-icon">
              <SVGDynamicIcon
                name="exclamation-inside-circle-custom-bg"
                width={24}
                height={24}
                customColor="red"
              />
            </span>
            {__t('proposal_tile_header.warning_text')}
          </div>
        )
      }
    </div>
  );
};

export default ProposalTileHeader;
